<pending-orders [maxAmount]="3"
                (startNewOrderClickEvent)="navigateToWebshopAndStartNewOrder()"></pending-orders>